export function useBrowserLocale(): string {
  const supportedLocales = ['en', 'pt'];

  const browserLocale = /-|_/.test(window.navigator.language)
    ? window.navigator.language.split(/-|_/)[0]
    : window.navigator.language;

  return supportedLocales.includes(browserLocale) ? browserLocale : supportedLocales[0];
}
